import React from "react";

const Row = props => {
  return <div className="row align-self-start">{props.children}</div>;
};

export default Row;
